export function LogoMark({ size = 18, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
      strokeLinecap="round"
      aria-hidden="true"
    >
      {/* polygons (outer hull) */}
      <path d="M4 6 L12 3.5 L20 8 L16.5 18 L7.5 16 Z" opacity="0.9" />
      {/* lines (triangulation edges to the centroid) */}
      <path d="M4 6 L12.5 11 M12 3.5 L12.5 11 M20 8 L12.5 11 M16.5 18 L12.5 11 M7.5 16 L12.5 11" opacity="0.7" />
      {/* points (vertices) */}
      <g fill="currentColor" stroke="none">
        <circle cx="4" cy="6" r="1.5" />
        <circle cx="12" cy="3.5" r="1.5" />
        <circle cx="20" cy="8" r="1.5" />
        <circle cx="16.5" cy="18" r="1.5" />
        <circle cx="7.5" cy="16" r="1.5" />
        <circle cx="12.5" cy="11" r="1.6" />
      </g>
    </svg>
  );
}
